export default "__VITE_ASSET__B9xP8He1__"